exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.comment[data-v-17a7aacc] {\r\n  font-style: italic;\r\n  font-weight: normal;\n}\n.w-130[data-v-17a7aacc] {\r\n  width: 130px;\n}\r\n", ""]);

// exports
